import React, { useState, useEffect } from "react";
import clienteAxios from "../../../config/axios";
import { Col, Result, Row } from "antd";
import Pagination from "../../../components/Pagination/pagination";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import "./ofertas.scss";
import Spin from "../../../components/Spin";
import CardOferta from "./card_oferta";
import { Container } from "@material-ui/core";

function Ofertas(props) {
  const { location, history } = props;
  const { page = 1 } = queryString.parse(location.search);
  const [productosPaginacion, setProductosPaginacion] = useState([]);

  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    obtenerProductos(40, page);
    window.scrollTo(0, 0);
  }, [page]);

  /* async function obtenerProductos(limit, page) {
		setLoading(true);
		await clienteAxios
			.get(`/productos/promociones?limit=${limit}&page=${page}`)
			.then((res) => {
				setProductos(res.data.posts.docs);
				setProductosPaginacion(res.data.posts);
				setLoading(false);
			})
			.catch((err) => {
				props.history.push('/error500');
			});
	} */
  async function obtenerProductos(limit, page) {
    setLoading(true);
    await clienteAxios
      .get(`/productos/promociones?limit=${limit}&page=${page}`)
      .then((res) => {
        const { docs } = res.data.posts;
        setProductos(docs);
        setProductosPaginacion(res.data.posts);
        setLoading(false);
      })
      .catch((err) => {
        props.history.push("/error500");
      });
  }

  const render = productos.map((promocion, index) => {
    const { productoPromocion, precioPromocion } = promocion;

    return (
      <Col key={index} xs={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }}>
        <CardOferta
          producto={productoPromocion}
          precioPromocion={precioPromocion}
        />
      </Col>
    );
  });

  if (!productos) {
    return (
      <div className="w-100 d-flex justify-content-center align-items-center">
        <Result status="404" title="Aun no hay ofertas" />
      </div>
    );
  }

  return (
    <Spin spinning={loading}>
      <div className="contenedor-home-background">
        <div className="row contenedor-home-banner">
          <p className="font-prin mb-0 text-center">
            ¡Encuentra ofertas todos los días!
          </p>
        </div>
      </div>
      <div className="my-3">
        <Container>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>{render}</Row>
        </Container>
      </div>
      <Pagination
        blogs={productosPaginacion}
        location={location}
        history={history}
      />
    </Spin>
  );
}

export default withRouter(Ofertas);
